module.exports = __webpack_public_path__ + "static/flowering-da22ed0936c01377cb3c9c1f358f0f94.jpg";